import { FormControl, FormHelperText, InputLabel, MenuItem, Select, } from '@mui/material';

import { Controller } from 'react-hook-form';
import React from 'react';

const SelectController = ({ name, label, control, options, errors, isLoading=false}) => {
  return (
    <FormControl error={Boolean(errors[name])} fullWidth>
      <InputLabel id="form-label-select">{label}</InputLabel>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Select {...field} fullWidth labelId="form-label-select" label={label} disabled={isLoading}
            >
          <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {Array.isArray(options) && options.map((option, index) => (
              <MenuItem key={index} value={option.value} >
                {option.label}
              </MenuItem>
            ))}
          </Select>
        )}
      />
      {errors[name] && <FormHelperText>{errors[name].message}</FormHelperText>}
    </FormControl>
  );
};

export default SelectController;


export const CustomSelectController = ({ name, label, control, options, errors, handleFields,  customStyle }) => {
  return (
    <FormControl error={Boolean(errors[name])} sx={{ width: customStyle ? "180px": "250px"}}>
      <InputLabel id="form-label-select">{label}</InputLabel>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Select {...field} sx={{width: customStyle ? "180px": "250px"}} labelId="form-label-select" label={label}
             onChange={(e)=>{handleFields(e.target.value);field.onChange(e.target.value)
            }}
            >
          <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {options.map((option, index) => (
          <MenuItem key={index} value={option.value} >
            {option.label}
          </MenuItem>
        ))}
          </Select>
        )}
      />
      {errors[name] && <FormHelperText>{errors[name].message}</FormHelperText>}
    </FormControl>
  );
};
